import React, { useState, useContext, useEffect, useCallback } from 'react'
import ProductContext from '@/product/context/product/productContext'
import AuthContext from '@/product/context/auth/authContext'

import './FavoriteCheckbox.css'

const FavoriteCheckbox = ({
    watchlisted,
    project_id,
    fill,
    addLabel,
    removeLabel,
    className = '',
    trigger = null,
    follows = '',
    add_watchlist_message,
    remove_watchlist_message,
    icon_type,
    emailFields,
}) => {
    const productContext = useContext(ProductContext)
    const authContext = useContext(AuthContext)
    const { isAuthenticated } = authContext

    const { addWatchlist, removeWatchlist, addFollower, getFollowers, increaseProductViewCount } =
        productContext

    const [checked, setChecked] = useState(parseInt(watchlisted) > 0)

    // ✅ Keep watchlisted in sync, but no need for cleanup reset
    useEffect(() => {
        setChecked(parseInt(watchlisted) > 0)
    }, [project_id, watchlisted])

    // ✅ useCallback to avoid re-creating function on every render
    const toggleFavourite = useCallback(() => {
        if (checked) {
            removeWatchlist({ project_id }, null, remove_watchlist_message)
            setChecked(false)
            return
        }

        if (trigger) trigger({ project_id })

        if (emailFields?.length) {
            addWatchlist({ project_id, emailFields }, null, add_watchlist_message)
        } else {
            addWatchlist({ project_id }, null, add_watchlist_message)
        }

        if (global?.watchCount === true) {
            increaseProductViewCount({ id: project_id })
        }

        if (follows) {
            addFollower({ follows, rating: 5 })
            setTimeout(getFollowers, 500)
        }

        setChecked(true)
    }, [
        checked,
        project_id,
        emailFields,
        trigger,
        follows,
        addWatchlist,
        removeWatchlist,
        addFollower,
        getFollowers,
        increaseProductViewCount,
        add_watchlist_message,
        remove_watchlist_message,
    ])

    if (!isAuthenticated) return null

    return (
        <div
            className={`favoriteCheck d-flex justify-content-center align-items-center ${
                checked ? 'checked' : ''
            } ${className}`}
        >
            {/* Keep input for accessibility, but hide visually */}
            <input
                id={project_id}
                type="checkbox"
                checked={checked}
                onChange={toggleFavourite}
                aria-label="Watchlist toggle"
            />

            {checked ? (
                <label htmlFor={project_id}>
                    <span className="material-icons">
                        {icon_type === 'visibility' ? 'visibility' : 'favorite'}
                    </span>
                    {removeLabel}
                </label>
            ) : (
                <label htmlFor={project_id}>
                    {fill ? (
                        <span className="material-icons ntChckd">favorite</span>
                    ) : (
                        <span
                            className={
                                icon_type === 'visibility'
                                    ? 'material-icons-outlined'
                                    : 'material-icons'
                            }
                        >
                            {icon_type === 'visibility' ? 'visibility' : 'favorite_border'}
                        </span>
                    )}
                    {addLabel}
                </label>
            )}
        </div>
    )
}

export default React.memo(FavoriteCheckbox)
